import React from 'react';
import PropTypes from 'prop-types';
import HelpButton from '../helpButton/helpButton';
import ProtectButton from '../protectButton/protectButton';

/**
 * Basic HTML label with a optional HelpButton atom.
 */
const Label = (props) => {
  const {
    children,
    helpText,
    className,
    protect,
    isProtected,
    setIsProtected
  } = props;

  return (
    <label htmlFor={children} className={`col-sm-4 col-form-label ${className}`}>
      {helpText !== ''
        && <HelpButton>{helpText}</HelpButton> 
        }
      {children}
      {protect && <ProtectButton isProtected={isProtected} setIsProtected={setIsProtected} />}
    </label>
  );
};

Label.propTypes = {
  /**
   * Label text
   */
  children: PropTypes.string.isRequired,
  /**
   * Help text inside the Help button popover,
   */
  helpText: PropTypes.string,
  /**
   * CSS class to customize the label
   */
  className: PropTypes.string,
};

Label.defaultProps = {
  helpText: '',
  className: '',
};

export default Label;
